// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + ({"45":"TabsFilter","90":"wix-bookings-services-preferences-modal","105":"DropdownFilterDeprecated","273":"TagsFilterDeprecated","342":"DropdownFilter","662":"TagsFilter","746":"TabsFilterDeprecated"}[chunkId] || chunkId) + ".chunk.min.css";
};